import React,{ useCallback, useEffect, useMemo } from "react";
import { useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import Table from "../../components/admin/Table";
import { getList, updateStatus, resetApiStatus } from "../../slices/LeaveSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import defaultConfig from "../../config/Config";
import ModelBox from "../../common/ModelBox";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import Modal from 'react-bootstrap/Modal';
import  moment  from 'moment';
import * as Yup from "yup";
import SelectBox  from "../../components/admin/SelectBox"
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import { MessageAlert } from "../../components/admin/MessageAlert";
import DatePicker from "react-datepicker";

export function List () {
    // const [todayDate, setTodayDate] = useState(new Date()) 
    const [pageName, setPageName] = useState('');
    const [pageTitle, setPageTitle] = useState('');
    const [businessData, setBusinessData] = useState([]);
    const [columsData, setColumsData] = useState([]);
    const data = useSelector((state) => state.leaves)
    const loading = useSelector( (state) => state.leaves.loading )
    const leavesProps = useSelector( (state) => state.leaves)
    const [searchParams, setSearchParams] = useSearchParams()
    const dispatch = useDispatch() 
    const params =  useParams() 
    const [modelData, setModelData] = useState({})
    const [modelContent, setModelContent] = useState("")
    const queryString = Object.fromEntries([...searchParams.entries()]) 
    const [leaveStatus, setLeaveStatus] = useState([])
    const [msgCompId, setMsgCompId] = useState('');
    const [serachString, setSearchString] = useState({
        date: moment(queryString.date).isValid() && queryString.date? new Date(queryString.date) : null,
        endDate: moment(queryString.endDate).isValid() && queryString.endDate? new Date(queryString.endDate) : null
      })
      console.log(moment(queryString.date).isValid())
      console.log(queryString)
    const [defaultParams, setDefaultParams] = useState({
        pageLength:defaultConfig.defaultLimit,
        page:1
    });

    const location = useLocation();
      
    const formSchema = Yup.object().shape({
        status: Yup.string().required("Please select status"),
        rejectReason: Yup.string().required("Please enter comment"),
    });
    const {
        register,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
      } = useForm({
        mode: "onBlur",
        resolver: yupResolver(formSchema),
      });

    useEffect( () => {
        setPageName(location.pathname)
        // setTodayDate(new Date())
    },[location])

    const getModelContent = useCallback( (data) => {
        setValue('leaveId', data._id)
        setValue('status', data.status)
        setValue('rejectReason', data.rejectReason)
        setModelContent(
            <React.Fragment>
            <form className="pb-0 mb-0" onSubmit={handleSubmit(onSubmit)}>
                <input
                    {...register("leaveId")}
                    type="hidden"
                />
                <Modal.Body>
                <div className="formDiv">
                    <div className="row">
                    <div className="col-3">
                            <div className="form-group mb-3">
                            <label
                                className={`input-label`}
                            >
                                Employe Name
                            </label>
                            <p className="lead">{data?.userDetail.name}</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group mb-3">
                            <label
                                className={`input-label`}
                            >
                                Start Date
                            </label>
                            <p className="lead">{moment(data?.from).format('LL')}</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group mb-3">
                            <label
                                className={`input-label ${errors.title && "error"}`}
                            >
                                End Date
                            </label>
                            <p className="lead">{moment(data?.to).format('LL')}</p>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="form-group mb-3">
                                <label
                                    className={`input-label`} >
                                    Status
                                </label>
                                <Controller
                                    control={control}
                                    name="status"
                                    render={({ field: { value, onChange } }) => (
                                    <SelectBox
                                        options={leaveStatus}
                                        isClearable={true}
                                        onChange={(opt) => onChange(opt?.value)}
                                        value={leaveStatus.find(
                                            (option) => option.value === value
                                        )}
                                    />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label
                                    className={`input-label`}>
                                    Leave Reason
                                </label>
                                <p className="lead">{data?.leaveReason}</p>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-8">
                            <div className="form-group mb-3">
                                <label
                                    className={`input-label ${errors.rejectReason && "error"}`}
                                >
                                    Comment
                                </label>
                                <textarea
                                    {...register("rejectReason")}
                                    type="text"
                                    id="floatingTextarea2" 
                                    style={{"height":"100px"}}
                                    className={`form-control ${
                                    errors.title && "error"
                                    }`}
                                />
                                {errors.coin && (
                                    <FormError message={errors.rejectReason.message} />
                                )}
                            </div>
                        </div>                
                    </div>
                </div>
                </Modal.Body>
                <Modal.Footer>
                <div className="col-12 mb-3 text-right">
                    <button type="button" onClick={closeModel} className="btn btn-outline-danger btn-lg mx-2">
                    Cancel
                    </button>        
                    <button type="submit" disabled={loading} className="btn btn-outline-success btn-lg mx-2">
                    {loading?"Updating...":"Update"}
                    </button>
                </div>
                </Modal.Footer>
            </form>
            
            </React.Fragment>
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[data, errors])
    
    const openEditPage = useCallback( (data) => {
        setModelData({
            data,
            show:true,
            size:"lg"
        })
        getModelContent(data)
    },[getModelContent])

    const columns = useMemo(()=>{
        const col = [
        {
            
            name:"Leave Start Date",
            sortable: true,
            center: true,
            selector: (row) => moment(row.from).format("LL"),
          },
          { 
            name:"Leave End Date",
            sortable: true,
            center: true,
            selector: (row) => moment(row.to).format("LL") ,
          },
          { 
            name:"Leave Reason",
            sortable: true,
            center: true,
            selector: (row) =>  row.leaveReason ,
          },
          { 
            name:"Comment",
            sortable: true,
            center: true,
            selector: (row) =>  row.rejectReason ,
          },
          {
            
            name:"Status",
            sortable: true,
            center: true,
            selector: (row) => row.status,
          }
        ]

        if (['/all-leaves-request', '/team-leaves-request'].indexOf(pageName) > -1) {
            col.unshift({
              name:"Emp Name",
              selector: (row) => row.userDetail.name,
              sortable: true,
              center: true,
            })
            col.push({
                name: "Action",
                width:"7%",
                button: false,
                center: true,
                cell: (row) => (
                    <>           
                        <button title="Add Coins" onClick={ ()=>openEditPage(row) } className="btn">
                            {" "}
                            <i className="fa fa-edit"></i>{" "}
                        </button>   
                    </>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
              }) 
        }

        return col
    // eslint-disable-next-line no-use-before-define
    },[openEditPage, pageName])   
    
    useEffect(()=>{
        setLeaveStatus(ToSelectOption(defaultConfig.leavesStatus, {value: 'value', label: 'label'}))
        if(Object.keys(queryString).length === 0){
            dispatch(getList({data:{...defaultParams, pageName}}))
        }else{
            setDefaultParams({...defaultParams, ...queryString}) 
        }
        switch(pageName){
            case '/team-leaves-request':
                setPageTitle('My Team Leave Request')
                break;
            case '/all-leaves-request':
                setPageTitle('All Leaves Request')
            break;
            default:
                setPageTitle('My Leaves Request')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[dispatch, pageName]);

    useEffect( () =>{
        setColumsData(columns)
    },[columns, defaultParams])

    
    useEffect( ()=>{
        setBusinessData(data)
    },[data])

    const onDateChange = (value, name) => {
        setSearchString({...serachString, [name]: value })
    }

    const searchInt = () => {
        let params = Object.assign(defaultParams, {pageLength: defaultConfig.defaultLimit, page:1, ...serachString})
        setSearchParams(params)  
        setDefaultParams(params)
        params.date = moment(params.date).format('YYYY-MM-DD')
        params.endDate = moment(params.endDate).format('YYYY-MM-DD')
        dispatch(getList({data:{...params, pageName}}))
    }

    const setPaginationData = (paginationData) =>{
        const params = {...defaultParams, page: paginationData.page, pageLength: paginationData.pageLength}
        setSearchParams(params)  
        setDefaultParams(params)
    }

    const resetSearch = () =>{
        const queryPrm = {pageLength: defaultConfig.defaultLimit, page: 1}
        setDefaultParams(queryPrm)
        setSearchParams(queryPrm)  
        dispatch(getList({data:{...queryPrm, pageName}}))
    }

    const closeModel = useCallback(() =>{
        setModelData({
            ...modelData,
            show:false
        })
        setModelContent("")
    },[modelData])

    useEffect( ()=>{
        if(leavesProps.actionType === "LEAVE_UPDATE"){
            closeModel()
            dispatch(resetApiStatus())
            setTimeout( () =>{
                dispatch(getList({data:{...defaultParams, pageName}}))
            }, 10)
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[closeModel, dispatch, leavesProps.actionType, pageName])

    const onSubmit = (data) => {
        setMsgCompId(new Date().getTime())
        dispatch(updateStatus(data))
    }
    return (
        <React.Fragment>
            <div className="revenue-wrapper">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card table-card">
                            <div className="d-sm-flex justify-content-between align-items-center pl-4 pr-4">
                                <h4 className="card-title mB25 mb-sm-0"><i className="fas fa-clock"></i> { pageTitle } </h4>
                            </div>
                            <div className="row m-3">
                                <div className="col-sm-6">
                                    <div className="row">
                                    <form className="form-inline">
                                        <div className="form-group">
                                            <div className="mr-1">
                                                <label style={{'justifyContent':'left'}} className="text-left">Leave Start Date</label>
                                                <DatePicker 
                                                selected={serachString.date}
                                                showMonthDropdown 
                                                showYearDropdown 
                                                className="form-control"
                                                placeholderText="Leave Start Date" 
                                                onChange={(date) => onDateChange(date, 'date')}
                                                />  
                                            </div>
                                            <div className="mr-1">
                                                <label style={{'justifyContent':'left'}}>Leave End Date</label>
                                                <DatePicker
                                                selected={serachString.endDate}
                                                className="form-control"
                                                onChange={(date) => onDateChange(date, 'endDate')}
                                                minDate={serachString.date}
                                                showMonthDropdown
                                                placeholderText = "Leave End Date"
                                                showYearDropdown
                                                />
                                            </div>
                                            <div className="mr-1">

                                            </div>
                                        </div>
                                        <div >
                                            <label>&nbsp;</label>
                                            <button onClick={searchInt} type="button" className="btn btn-primary btn-lg">
                                                <i className="fa fa-search"></i>
                                            </button>
                                            &nbsp;
                                            <button type="reset" onClick={resetSearch} title="Reset" className="btn btn-primary btn-lg">
                                                <i className="fas fa-undo"></i>
                                            </button>
                                        </div>
                                    
                                    </form>
                                    </div>
                                </div>
                            </div>
                            <Table 
                                totalCount={businessData.totalCount}
                                type={params.type}
                                data={businessData.list} 
                                columns={columsData} 
                                dataLoadFnc={getList} 
                                extraConfig = {{...defaultParams, pageName}}
                                loading={loading}  
                                callBack={setPaginationData}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ModelBox
                data={{
                    size: "md", 
                    ...modelData,
                    content: modelContent,
                    title: "Update Leaves Status"
                }}
            />

            <MessageAlert
                id={msgCompId}
                type={ (()=>{
                    if(leavesProps.success){
                        return "success"
                    }else if(!leavesProps.success){
                        return "error"
                    }
                })()}
                message={leavesProps.message}
            />
        </React.Fragment>
    )

}